export default __webpack_public_path__ + "static/media/Dollar.3aea5aff.png";